var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelevantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "143px",
    height: "60px",
    viewBox: "0 0 143 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon relevant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBBCMC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up/Relevant-1",
    transform: "translate(-887.000000, -562.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up",
    transform: "translate(780.000000, 321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards",
    transform: "translate(72.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-relevant",
    transform: "translate(37.335329, 86.278302)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    stroke: "#1D1D1B",
    strokeWidth: 2.149,
    points: "125.02835 40.2306176 139.041916 26.29517 125.02835 12.3551905"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    stroke: "#1D1D1B",
    strokeWidth: 2.149,
    points: "14.0135658 40.2306176 0 26.29517 14.0135658 12.3551905"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(39.910180, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7862328,59.2358491 C46.2379312,59.2358491 59.5724657,45.9756475 59.5724657,29.6156586 C59.5724657,13.2556697 46.2379312,0 29.7862328,0 C13.3345345,0 0,13.2556697 0,29.6156586 C0,45.9756475 13.3345345,59.2358491 29.7862328,59.2358491 Z",
    id: "Stroke-5",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FEFEFE",
    points: "20.5988024 18.0283019 20.5988024 41.2075472 43.7724551 29.6179245"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelevantIcon);
export default __webpack_public_path__ + "static/media/relevant_icon.62ae71f9d0a8ae3ecf406f6a8514f1f0.svg";
export { ForwardRef as ReactComponent };